// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.T3ApNm60B1ap1ZmVLkSx {
  display: flex;
  align-items: center;
  width: fit-content;
  column-gap: 12px;
  border-radius: 16px;
}
.T3ApNm60B1ap1ZmVLkSx ._87qquY3RLP6FPO61RgJw,
.T3ApNm60B1ap1ZmVLkSx .FkP6oP82atgVfj6aad3Z {
  display: block;
  position: relative;
  border: unset;
  outline: unset;
  background-color: transparent;
  margin: 0;
  padding: 8.5px 12px;
  border-radius: 11px;
  border: 1px solid transparent;
  font-size: 16px;
  line-height: 19.2px;
  font-weight: 400;
  transition: 0.3s ease-out;
}
.T3ApNm60B1ap1ZmVLkSx .FkP6oP82atgVfj6aad3Z {
  color: #fff;
}
.T3ApNm60B1ap1ZmVLkSx .FkP6oP82atgVfj6aad3Z:hover {
  cursor: pointer;
  background-color: rgba(99, 99, 99, 0.4);
}
.T3ApNm60B1ap1ZmVLkSx .FkP6oP82atgVfj6aad3Z:focus-visible {
  border-radius: 0;
  border: 1px solid #fff;
}
.T3ApNm60B1ap1ZmVLkSx .FkP6oP82atgVfj6aad3Z:active {
  color: #fff;
  transition: all 0.3s;
}
.T3ApNm60B1ap1ZmVLkSx .FkP6oP82atgVfj6aad3Z.L41u5S5KHXXkYVEPPtxZ {
  color: #636363;
  transition: all 0.3s;
  cursor: not-allowed;
}
.T3ApNm60B1ap1ZmVLkSx ._87qquY3RLP6FPO61RgJw {
  color: #fff;
  background-color: #636363 !important;
}
.T3ApNm60B1ap1ZmVLkSx ._87qquY3RLP6FPO61RgJw:focus-visible {
  border-radius: 11px;
  border: 1px solid #fff;
  background-color: #262626;
}
.T3ApNm60B1ap1ZmVLkSx ._87qquY3RLP6FPO61RgJw:active {
  background-color: #1e1e1e;
  transition: all 0.3s;
}
.T3ApNm60B1ap1ZmVLkSx ._87qquY3RLP6FPO61RgJw.L41u5S5KHXXkYVEPPtxZ {
  background-color: rgba(50, 50, 50, 0.6);
  color: #636363;
}`, "",{"version":3,"sources":["webpack://./src/editor/components/elements/Tabs/Tabs.module.scss","webpack://./src/editor/style/variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAAF;AAEE;;EAEE,cAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,6BAAA;EAEA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EAEA,eAAA;EACA,mBAAA;EACA,gBAAA;EAEA,yBAAA;AAHJ;AAME;EACE,WCZI;ADQR;AAMI;EACE,eAAA;EACA,uCAAA;AAJN;AAOI;EACE,gBAAA;EACA,sBAAA;AALN;AAQI;EACE,WCzBE;ED0BF,oBAAA;AANN;AASI;EACE,cCZK;EDaL,oBAAA;EACA,mBAAA;AAPN;AAWE;EACE,WCrCI;EDsCJ,oCAAA;AATJ;AAWI;EACE,mBAAA;EACA,sBAAA;EACA,yBChBM;ADOZ;AAYI;EACE,yBCjBM;EDkBN,oBAAA;AAVN;AAaI;EACE,uCAAA;EACA,cCnCK;ADwBX","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `T3ApNm60B1ap1ZmVLkSx`,
	"activeTab": `_87qquY3RLP6FPO61RgJw`,
	"inactiveTab": `FkP6oP82atgVfj6aad3Z`,
	"disabled": `L41u5S5KHXXkYVEPPtxZ`
};
export default ___CSS_LOADER_EXPORT___;
